export const defaultFilters = {
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    dateFrom: '',
    dateTo: '',
    orderPriceFrom: '',
    orderPriceTo: '',
    ids: '',
    cpaId: '',
    prepayment: '',
    search: '',
    historyDateFrom: '',
    historyDateTo: '',
    favorite: 0,
    userGroup: [],
    operators: [],
    countries: [],
    regions: [],
    districts: [],
    cities: [],
    products: [],
    offerGroups: [],
    offers: [],
    salesTypes: [],
    niches: [],
    webId: [],
    attributes: [],
    callbackReasons: [],
    status: [],
    orderSubstatus: [],
    historyStatus: [],
    landings: [],
    tags: [],
    warehouses: [],
    deliveryServices: [],
    statusReasons: [],
    callbackCounts: [],
    historySubstatus: [],
    inverted: [],
  },
  order: { id: 'DESC' },
  clientOptions: {
    filterPanelExpanded: false,
    selectedColumns: [],
  },
}
